import axios from 'axios';

const URL = 'https://bitter-octopus-35.telebit.io'; // 'https://6d0e-141-145-204-58.eu.ngrok.io';

async function setNFTImage(selectedFile, nftId, address, signature) {
  // Create an object of formData
  const formData = new FormData();

  // Update the formData object
  formData.append(
    "file",
    selectedFile,
    selectedFile.name
  );

  formData.append('nftId', nftId);
  formData.append('address', address);
  formData.append('signature', signature);


  // Request made to the backend api
  // Send formData object
  await axios.post(URL + '/nft-image-upload', formData);
}

function getNFTURL(nftId) {
  return URL + '/nft-image?nftId=' + nftId;
}


export default {
  setNFTImage,
  getNFTURL
};

